var map = {
	"./arrow-for-dev.webp": 2518,
	"./developer.webp": 2417,
	"./footer-tec-four.webp": 7878,
	"./img-card01.webp": 7358,
	"./img-card02.webp": 4511,
	"./img-card03.webp": 2972,
	"./img-card04.webp": 2189,
	"./logo.webp": 1238,
	"./project-motorsbr.webp": 7271,
	"./project-proimprensa.webp": 915,
	"./projects/ProImprensa.webp": 4340,
	"./projects/ProImprensa2.webp": 6822,
	"./projects/ProImprensa3.webp": 449,
	"./projects/motorsbr.webp": 5790,
	"./projects/motorsbr2.webp": 4288,
	"./projects/motorsbr3.webp": 4691,
	"./tecnologias-mobile.webp": 6530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8379;